import { render, staticRenderFns } from "./choose-company.vue?vue&type=template&id=5ec20b1f&scoped=true"
import script from "./choose-company.vue?vue&type=script&lang=js"
export * from "./choose-company.vue?vue&type=script&lang=js"
import style0 from "./choose-company.vue?vue&type=style&index=0&id=5ec20b1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec20b1f",
  null
  
)

export default component.exports